export enum RequestStageNames {
  'AOR Approval',
  'Legal Review',
  'Procurement Review',
  'QAA Approval',
  'TAC Approval',
  'Finance',
}

export enum StageType {
  APPROVAL,
  REVIEW,
}

export enum RequestStates {
  DRAFT,
  IN_PROGRESS,
  AWAITING_APPROVAL,
  PENDING_REVIEW,
  REVIEW_PROGRESS,
  REVIEWED,
  APPROVED,
  REJECTED,
  COMPLETED,
  CANCELLED,
}

export const requestStateToColorClass = (state: string) => {
  switch (state) {
    case RequestStates[RequestStates.DRAFT]:
      return 'bg-yellow-100 text-yellow-600'
    case RequestStates[RequestStates.IN_PROGRESS]:
      return 'bg-yellow-100 text-yellow-600'
    case RequestStates[RequestStates.AWAITING_APPROVAL]:
      return 'bg-yellow-100 text-yellow-600'
    case RequestStates[RequestStates.PENDING_REVIEW]:
      return 'bg-yellow-100 text-yellow-600'
    case RequestStates[RequestStates.REVIEW_PROGRESS]:
      return 'bg-yellow-100 text-yellow-600'
    case RequestStates[RequestStates.APPROVED]:
      return 'bg-green-100 text-green-600'
    case RequestStates[RequestStates.REVIEWED]:
      return 'bg-green-100 text-green-600'
    case RequestStates[RequestStates.REJECTED]:
      return 'bg-red-100 text-red-600'
    case RequestStates[RequestStates.COMPLETED]:
      return 'bg-green-100 text-green-600'
    case RequestStates[RequestStates.CANCELLED]:
      return 'bg-red-100 text-red-600'
    default:
      return 'bg-yellow-100 text-yellow-600'
  }
}
